import { render, staticRenderFns } from "./WarehouseDash.vue?vue&type=template&id=d5c074a4"
import script from "./WarehouseDash.vue?vue&type=script&lang=js"
export * from "./WarehouseDash.vue?vue&type=script&lang=js"
import style0 from "./WarehouseDash.vue?vue&type=style&index=0&id=d5c074a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports